import { render, staticRenderFns } from "./item-input.vue?vue&type=template&id=99d288c4&scoped=true"
import script from "./item-input.vue?vue&type=script&setup=true&lang=js"
export * from "./item-input.vue?vue&type=script&setup=true&lang=js"
import style0 from "./item-input.vue?vue&type=style&index=0&id=99d288c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d288c4",
  null
  
)

export default component.exports